// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1iPvU","requiredAsterisk":"Info_requiredAsterisk__3cARy"};